module.exports = __webpack_public_path__ + "static/media/feature-1-bollettini.0824e8da.png";